<template>
    <div class="home">
        <section class="hero">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">
                        {{ heading }}
                    </h1>
                    <div class="is-two-thirds column is-paddingless">
                        <h2 class="subtitle is-4">{{ subheading }}</h2>
                    </div>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="columns pd is-desktop">
                    <div class="column is-one-quarter-desktop">
                        <p class="title"><img src="../assets/ISAlogo200px.png" alt="ISA" /></p>
                    </div>
                    <div class="column is-two-thirds-desktop info">

                        <h3>Speakers:</h3>
                        <ul>
                            <li><a href="http://www.eeecs.qub.ac.uk/~c.decampos/" target="_blank">Cassio P. de Campos</a>, Reader with the Centre for Data Science and Scalable Computing, Queen's University Belfast</li>
                            <li><a href="http://people.idsia.ch/~alessandro/">Alessandro Antonucci</a>, Senior Researcher, Swiss AI Lab IDSIA</li>
                        </ul>

                        <h3>Course description:</h3>
                        <p>
                            Probabilistic models usually need a sharp estimate of their parameters in order to represent a (single) distribution, even if a precise elicitation might be unreliable because of limited expert knowledge, or observations might be scarce, incomplete and/or noisy. Instead, one may resort to sets of probability distributions to represent their knowledge, adopting the so-called theory of imprecise probability. During this tutorial we introduce the main concepts of such methods and present a number of techniques based on it that are designed to cope with uncertainty in a principled robust manner and to yield reliable results. We discuss on robust decision making and sensitivity analysis. Applications in computer vision, pattern recognition and decision support in knowledge-based expert systems are also provided.
                            <br /><br />
                            The course will consist of four lectures. Tea/coffee breaks and lunch are included in the registration fee.
                            <br />
                            You can register by e-mailing <a href="mailto:wyseja@tcd.ie">wyseja@tcd.ie</a>.
                            <br /><br />
                            The course is sponsored by the <a href="http://www.istat.ie/drupal/" target="_blank">Irish Statistical Association</a>.
                        </p>

                    </div>
                </div>
            </div>

            <div class="columns pd is-multiline is-desktop">
                <div class="column is-one-third-desktop">
                    <div class="card">
                        <div class="card-content">
                            <h2 class="title">Venue of the event</h2>
                            <p class="subtitle"><i class="fa fa-map-marker" aria-hidden="true"></i>
                                <a href="https://www.google.ie/maps/place/O'Callaghan+Mont+Clare+Hotel/@53.3414972,-6.2530017,17z/data=!3m1!4b1!4m5!3m4!1s0x48670e90db4a8129:0xcf06339f781c38e2!8m2!3d53.341494!4d-6.250813" target="_blank">
                                    O'Callaghan Mont Clare Hotel<br />
                                    1-4 Merrion Street Lower, Dublin 2
                                </a>
                            </p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-content">
                            <h2 class="title">Registration fees</h2>
                            <p class="subtitle is-vcentered">
                                <i class="fa fa-eur" aria-hidden="true"></i>Student €20, full €30<br />
                                Discount for ISA members 50%
                            </p>
                        </div>
                    </div>
                </div>
                <div class="column is-two-thirds-desktop">
                    <div class="card schedule">
                        <div class="card-content">
                            <h2 class="title">Schedule of events</h2>
                            <p class="subtitle">Tuesday, 14th of November, 2017</p>
                            <ul class="subtitle is-vcentered">
                                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>9:00 am - 9:30 am:</span> Register</li>
                                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>9:30 am - 10:30 am:</span> Lecture 1</li>
                                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>10:30 am - 10:45 am:</span> Coffee break</li>
                                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>10:45 am - 11:45 am:</span> Lecture 2</li>
                                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>11:45 am - 12:45 am:</span> Lunch</li>
                                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>12:45 am - 13:45 am:</span> Lecture 3</li>
                                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>13:45 am - 14:00 am:</span> Coffee break</li>
                                <li><i class="fa fa-clock-o" aria-hidden="true"></i><span>14:00 am - 15:00 am:</span> Lecture 4</li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: 'isa',
        beforeCreate: function() {
            document.body.className = 'isa';
        },
        data () {
            return{
                heading: 'Imprecise Probability - A Gentle Overview',
                subheading: 'ISA short course'
            }

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
    @import "../mq"

    .hero
        background: url('../assets/front-facade-high.jpg')
        background-size: cover
        min-height: 500px

        .title
            margin-top: 0 !important
            font-size: 3.5rem !important
            +mobile
                font-weight: bold
            +tablet
                font-size: 2.5rem
            +desktop
                font-size: 4rem
                margin-top: 2rem

    h2
        margin: 1.5rem 0 2rem 0 !important
        .subtitle
            font-size: 2rem !important

    h3
      font-weight: bold

    .fa-cog
        font-size: 40px

    #learn
        +desktop
            margin-bottom: 2rem

    .pd
        +tablet
            padding: 2em 0

    .column div
        margin-bottom: 15px

    .card
        border-radius: 5px
        -moz-border-radius: 5px
        -webkit-border-radius: 5px
        height: calc(50% - 15px)
        height: -webkit-calc(50% - 15px)
        height:    -moz-calc(50% - 15px)

        &.schedule
            height: calc(100% - 15px)
            height: -webkit-calc(100% - 15px)
            height:    -moz-calc(100% - 15px)

    .card-content
        .subtitle
            margin-top: 10px

    ul.subtitle
        padding: 10px 30px

        li
            padding-bottom: 5px

    i
        padding: 5px 10px 5px 0
        height: 100%

    .info
        padding: 20px

        p, ul
            margin-bottom: 20px

        p
            padding: 20px 0

        ul
          margin-left: 25px
          padding: 10px 20px

        li
            list-style-type: disc

    .schedule
        span
            font-style: italic
</style>



// WEBPACK FOOTER //
// src/components/Isa.vue?b3349874